import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-task-status-badge',
  template: `
    <span class="badge" [ngClass]="badgeClass">
      {{ status | uppercase }}
    </span>
  `,
  styles: [`
    .badge { 
        font-size: 0.65rem; 
        padding: 0.35rem 0.75rem; 
        border-radius: 50rem;
        font-weight: 700;
        letter-spacing: 0.03em;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    
    /* Light Colors (Modern look) */
    .bg-light-todo { background-color: rgba(40, 167, 69, 0.1); color: #28a745; border: 1px solid rgba(40, 167, 69, 0.2); }
    .bg-light-done { background-color: rgba(108, 117, 125, 0.1); color: #6c757d; border: 1px solid rgba(108, 117, 125, 0.2); }
    .bg-light-confirmed { background-color: rgba(0, 123, 255, 0.1); color: #007bff; border: 1px solid rgba(0, 123, 255, 0.2); }
    
    /* Solid Colors fallback */
    .bg-todo { background-color: #28a745; color: white; }
    .bg-done { background-color: #6c757d; color: white; }
    .bg-confirmed { background-color: #007bff; color: white; }
  `]
})
export class TaskStatusBadgeComponent {
  @Input() status: string = '';
  @Input() mode: 'solid' | 'light' = 'solid';

  get badgeClass(): string {
    const s = this.status?.toLowerCase() || 'unknown';
    const prefix = this.mode === 'light' ? 'bg-light-' : 'bg-';

    // Map status to class suffix
    let suffix = 'secondary';
    if (s === 'todo') suffix = 'todo';
    if (s === 'done') suffix = 'done';
    if (s === 'confirmed') suffix = 'confirmed';

    // Fallback logic could be added here
    if (suffix === 'secondary' && this.mode === 'light') return 'bg-light text-dark border'; // Default light

    return prefix + suffix;
  }
}
